// Maps opponent team names to ESPN stats page URLs based on sport type
export const getTeamStatsUrl = (teamName, sport) => {
  if (!teamName || !sport) return null;
  const name = teamName.toLowerCase();
  const s = sport.toLowerCase();

  const mlbTeams = {
    'angels': 'laa', 'astros': 'hou', 'athletics': 'oak', 'blue jays': 'tor',
    'braves': 'atl', 'brewers': 'mil', 'cardinals': 'stl', 'cubs': 'chc',
    'diamondbacks': 'ari', 'd-backs': 'ari', 'dodgers': 'lad', 'giants': 'sf',
    'guardians': 'cle', 'mariners': 'sea', 'marlins': 'mia', 'mets': 'nym',
    'nationals': 'wsh', 'orioles': 'bal', 'padres': 'sd', 'phillies': 'phi',
    'pirates': 'pit', 'rangers': 'tex', 'rays': 'tb', 'reds': 'cin',
    'red sox': 'bos', 'rockies': 'col', 'royals': 'kc', 'tigers': 'det',
    'twins': 'min', 'white sox': 'chw', 'yankees': 'nyy',
  };

  const nbaTeams = {
    'hawks': 'atl', 'celtics': 'bos', 'nets': 'bkn', 'hornets': 'cha',
    'bulls': 'chi', 'cavaliers': 'cle', 'cavs': 'cle', 'mavericks': 'dal',
    'nuggets': 'den', 'pistons': 'det', 'warriors': 'gs', 'rockets': 'hou',
    'pacers': 'ind', 'clippers': 'lac', 'lakers': 'lal', 'grizzlies': 'mem',
    'heat': 'mia', 'bucks': 'mil', 'timberwolves': 'min', 'wolves': 'min',
    'pelicans': 'no', 'knicks': 'ny', 'thunder': 'okc', 'magic': 'orl',
    '76ers': 'phi', 'sixers': 'phi', 'suns': 'phx', 'trail blazers': 'por',
    'blazers': 'por', 'kings': 'sac', 'spurs': 'sa', 'raptors': 'tor',
    'jazz': 'uta', 'wizards': 'wsh',
  };

  const nhlTeams = {
    'ducks': 'ana', 'bruins': 'bos', 'sabres': 'buf', 'flames': 'cgy',
    'hurricanes': 'car', 'blackhawks': 'chi', 'avalanche': 'col',
    'blue jackets': 'cbj', 'stars': 'dal', 'red wings': 'det', 'oilers': 'edm',
    'panthers': 'fla', 'kings': 'la', 'wild': 'min', 'canadiens': 'mtl',
    'predators': 'nsh', 'devils': 'njd', 'islanders': 'nyi', 'rangers': 'nyr',
    'senators': 'ott', 'flyers': 'phi', 'penguins': 'pit', 'sharks': 'sj',
    'kraken': 'sea', 'blues': 'stl', 'lightning': 'tb', 'maple leafs': 'tor',
    'canucks': 'van', 'golden knights': 'vgk', 'capitals': 'wsh', 'jets': 'wpg',
    'utah hockey': 'uta',
  };

  const nflTeams = {
    'bears': 'chi', 'bengals': 'cin', 'bills': 'buf', 'broncos': 'den',
    'browns': 'cle', 'buccaneers': 'tb', 'bucs': 'tb', 'cardinals': 'ari',
    'chargers': 'lac', 'chiefs': 'kc', 'colts': 'ind', 'commanders': 'wsh',
    'cowboys': 'dal', 'dolphins': 'mia', 'eagles': 'phi', 'falcons': 'atl',
    '49ers': 'sf', 'giants': 'nyg', 'jaguars': 'jax', 'jets': 'nyj',
    'lions': 'det', 'packers': 'gb', 'panthers': 'car', 'patriots': 'ne',
    'raiders': 'lv', 'rams': 'lar', 'ravens': 'bal', 'saints': 'no',
    'seahawks': 'sea', 'steelers': 'pit', 'texans': 'hou', 'titans': 'ten',
    'vikings': 'min',
  };

  let teams, league;
  if (s === 'baseball') { teams = mlbTeams; league = 'mlb'; }
  else if (s === 'basketball') { teams = nbaTeams; league = 'nba'; }
  else if (s === 'hockey') { teams = nhlTeams; league = 'nhl'; }
  else if (s === 'football') { teams = nflTeams; league = 'nfl'; }
  else return null;

  for (const [keyword, abbr] of Object.entries(teams)) {
    if (name.includes(keyword)) {
      return `https://www.espn.com/${league}/team/_/name/${abbr}`;
    }
  }

  // Fallback: ESPN search
  return `https://www.espn.com/search/_/q/${encodeURIComponent(teamName)}`;
};


// Returns an iframe-friendly URL for team stats (Google search with igu=1)
export const getTeamIframeUrl = (teamName, sport) => {
  if (!teamName || !sport) return null;
  const s = sport.toLowerCase();
  if (s === 'family' || s === 'concerts') return null;
  const league = s === 'baseball' ? 'MLB' : s === 'basketball' ? 'NBA' : s === 'hockey' ? 'NHL' : s === 'football' ? 'NFL' : '';
  return `https://www.google.com/search?igu=1&q=${encodeURIComponent(teamName)}+${league}+schedule+stats`;
};
